export const satoshiLines = {
  hotel: {
    lines: [
      { speaker: "Satoshi", text: "Yo, vibes kinda chill,\nLike my turtle on sun days—\nYou cool? Then we cool." },
      { speaker: "Randy", text: "I once had a pet.\nIt was a hotdog. Briefly.\nI still mourn that dog." },

      { speaker: "Satoshi", text: "Bro, don’t overthink—\nEven leaves just drop and drift.\nJust be real, y’know?" },
      { speaker: "Randy", text: "Leaves fall all the time—\nI slipped, cried, and spilled my fries.\nNature has no chill." },

      { speaker: "Satoshi", text: "I write late at night,\nTurtle sleeps, stars peep at me—\nTruth hits when it’s quiet." },
      { speaker: "Randy", text: "Stars winked at me once—\nbut I’d had six sake shots.\nStill counts, I think. Right?" }
    ],
    voices: [
      "satoshi_hotel1",
      "satoshi_hotel2",
      "satoshi_hotel3"
    ],
    randyVoices: [
      "randy_satoshi1",
      "randy_satoshi2",
      "randy_satoshi3"
    ]
  }
};

export default satoshiLines;
